import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import {
  blackColor,
  borderTextbox,
  primaryColor,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import FormInputBox from "../../../components/Input/FormInputBox";

function DateSearchFilterWithlabel({
  label,
  time,
  required,
  onTimeChange,
  errorMsg,
  setSearchValues,
  data,
  hideLabel,
  gap,
  mb,
}) {
  return (
    <Box>
      {!hideLabel && (
        <Typography
          variant="h3"
          fontSize={14}
          color={blackColor}
          fontWeight={500}
          mb={"8px !important"}
          display="inline"
        >
          {label}
        </Typography>
      )}{" "}
      {required ? (
        <Typography variant="body1" sx={{ display: "inline", color: "#f00" }}>
          *
        </Typography>
      ) : null}
      <Grid container spacing={gap ? gap : 1}>
        <Grid item md={6}>
          <FormInputBox
            label="From"
            placeholder=""
            value={data?.from}
            onChange={({ target }) => {
              setSearchValues({
                from: target.value,
                to: data?.to,
              });
            }}
            inputType="date"
            disableFeatureDate
            // required
            error={data?.errors?.startDate}
            bordervalues={borderTextbox}
            mb={mb}
          />
        </Grid>
        <Grid item md={6}>
          <FormInputBox
            label="To"
            placeholder=""
            value={data?.to}
            onChange={({ target }) => {
              setSearchValues({
                from: data?.from,
                to: target.value,
              });
            }}
            inputType="date"
            error={data?.errors?.startDate}
            bordervalues={borderTextbox}
            disableFeatureDate
            mb={mb}
          />
        </Grid>
      </Grid>
      {errorMsg ? (
        <Typography variant="subtitle1" component="p" fontSize={13} color="red">
          {errorMsg}
        </Typography>
      ) : null}
    </Box>
  );
}

export default DateSearchFilterWithlabel;

const styles = {
  actionBtn: {
    background: primaryColor,
    padding: { md: "5px 20px", xs: "5px" },
    fontSize: "13px",
    color: whiteColor,
    borderRadius: "5px",
    fontWeight: 600,
    border: "1px solid " + primaryColor,

    "&:hover": {
      backgroundColor: whiteColor,
      color: primaryColor,
      border: "1px solid " + primaryColor,
    },
  },
  inputBox: (color) => ({
    border: borderTextbox,
    borderRadius: "4px",
    fontSize: "13px",
    color: "#777",
    background: color,
    padding: { md: "3px 12px", xs: "4px 10px" },
    width: "100%",
    "& .MuiInputBase-root.Mui-disabled": {
      color: blackColor + " !important",
    },
  }),
};
